export default "__VITE_ASSET__DVLbbVza__"